<!-- 获奖记录 -->
<template>
  <popup-frame ref="records" size="md">
    <div :class="$style.records">
      <template v-if="list.length">
        <p style="font-size: 0.26rem; text-align: center; line-height: 1.5">
          <em>
            游戏奖励将直接发放至绑定角色的游戏内邮箱中，<br />周边奖励将在活动结束后15个工作日内寄送
          </em>
        </p>
        <div :class="$style['records-table']">
          <div :class="[$style['records-row'], $style['records-row-header']]">
            <span>奖励内容</span>
          </div>
          <div style="height: 2.5rem; overflow-y: auto">
            <div v-for="(el, index) in list" :key="index" :class="$style['records-row']">
              <span>
                {{ el.award_name }}
              </span>
            </div>
          </div>
        </div>
        <button v-if="hasTangiblePrize" :class="$style.address" @click="onBindAddress">
          {{ Object.keys(addressData).length ? '查看地址' : '填写地址' }}
        </button>
      </template>
      <div
        v-else
        style="padding-top: 0.7rem; font-size: 0.3rem; line-height: 1.8; text-align: center"
      >
        <p style="font-size: 0.4rem; margin-bottom: 0.2rem">暂无获奖记录!</p>
        <p v-if="noRecordsTip" style="padding: 0 0.2rem" v-html="noRecordsTip" />
      </div>
    </div>
  </popup-frame>
</template>

<script>
import { mapGetters } from 'vuex'
import { fetchAwardRecord } from '@/api'
import { PopupFrame } from '@/components/widgets'

export default {
  name: 'ThePrizeRecords',
  components: { PopupFrame },
  data() {
    return {
      list: [],
      /** 是否有实物奖励 */
      hasTangiblePrize: false,
      /** 实物奖励名称 */
      tangiblePrizeName: ''
    }
  },
  computed: {
    ...mapGetters(['addressData', 'noRecordsTip'])
  },
  methods: {
    async showRecords() {
      const { data = {} } = await fetchAwardRecord()
      // 简化奖励列表结构
      this.list = data.list

      // 查询实物奖信息
      const prize = this.list.find(el => el.type === 2)
      if (prize) {
        this.hasTangiblePrize = true
        this.tangiblePrizeName = prize.award_name
      } else {
        this.hasTangiblePrize = false
        this.tangiblePrizeName = ''
      }

      this.$refs.records.show()
    },
    show() {
      this.showRecords()
    },
    onCopySuccess() {
      this.$toast('复制礼包成功')
    },
    onCopyError() {
      this.$toast('复制失败，请换个浏览器试试！')
    },
    onBindAddress() {
      this.$emit('bind-address', this.tangiblePrizeName)
    }
  }
}
</script>

<style lang="less" module>
@item-height: 0.6rem;

.records {
  &::before {
    .size(7.08rem, 1.87rem);
    .background-fill('./images/title.png');

    content: '';
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
  }

  &-table {
    width: 90%;
    margin: 0.2rem auto 0;
  }

  &-row {
    height: @item-height;
    display: flex;
    justify-content: center;
    align-items: center;

    &-header {
      font-size: 0.28rem;
      border-bottom: 1px solid #fff;
      margin-bottom: 0.2rem;

      span {
        &::before {
          .size(0.45rem, 0.49rem);
          .background-fill('./images/icon.png');

          content: '';
          display: inline-block;
          margin-right: 0.04rem;
        }
      }
    }

    > span {
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

.address {
  position: absolute;
  top: 0.35rem;
  right: 1.4rem;
  padding-bottom: 0.1rem;
  font-size: 0.25rem;
  font-weight: 700;
  border-bottom: 1px solid #aeccf9;
  color: #aeccf9;
}
</style>
